import { Injectable } from '@angular/core';
import { MessageModel } from '../maintenance.message/model/message.model';
import { AuthService } from '../../services/auth.service';

import * as $ from 'jquery';

@Injectable()
export class MaintenanceMessageModalService {

  public modalMessage: MessageModel;

  set message(m: MessageModel) {
    if (m) {
      this.modalMessage = m;
      if (this.authService.isAuthorized) {
        this.authService.logout();
      }
      this.openModal();
    } else {
      if (this.modalMessage !== undefined) {
        this.closeModal();
      }
      this.modalMessage = undefined;
    }
  }

  constructor(private authService: AuthService) {
  }

  private openModal() {
    $('#maintenanceModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#maintenanceModal').modal('show');
  }

  private closeModal() {
    $('#maintenanceModal').modal('hide');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maintenance.message.modal/maintenance.message.modal.service.ts